import * as Styled from './LinkButton.styled';
import { LinkButtonProps } from './LinkButton.types';
import React from 'react';

const LinkButton = React.forwardRef<HTMLButtonElement, LinkButtonProps>(
  (props, ref) => {
    const {
      children,
      type = 'button',
      leading,
      trailing,
      intent = 'primary',
      orientation = 'horizontal',
      ...rest
    } = props;
    return (
      <Styled.LinkButton
        type={type}
        intent={intent}
        ref={ref}
        {...rest}
        orientation={orientation}
      >
        {!!leading && <Styled.Leading>{leading}</Styled.Leading>}
        {children}
        {!!trailing && <Styled.Trailing>{trailing}</Styled.Trailing>}
      </Styled.LinkButton>
    );
  },
);

export default LinkButton;
